import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { useTenantPath } from '../hooks/useTenant';
import { useTenantBranding } from '../context/TenantBrandingContext';
import { useBannerHeightCssVar } from '../hooks/useBannerHeightCssVar';
import './AppFooter.css';

/**
 * Schlanke Fußzeile für den authentifizierten App-Bereich (TenantLayout).
 * Verlinkt die tenantspezifischen Rechtstexte (Impressum, AGB,
 * Datenschutzerklärung), die über LegalDocumentPage gerendert werden.
 */
const AppFooter = () => {
  const { buildPath } = useTenantPath();
  const { name } = useTenantBranding();
  const year = new Date().getFullYear();
  // Veröffentlicht die tatsächliche Footer-Höhe als --app-footer-height auf <html>,
  // damit Seiten mit Vollhöhen-Scrollcontainern (calc(100vh - …)) den Footer einrechnen.
  const footerRef = useBannerHeightCssVar(true, '--app-footer-height');

  return (
    <footer id="app-footer" className="app-footer" role="contentinfo" ref={footerRef}>
      <Container className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 py-2">
        <small id="app-footer-copyright" className="text-muted">
          &copy; {year} {name || 'Mietvertrag-Generator'}
        </small>
        <nav aria-label="Rechtliches" id="app-footer-legal-nav">
          <ul className="list-inline mb-0" id="app-footer-legal-list">
            <li className="list-inline-item">
              <Link id="app-footer-impressum" to={buildPath('/impressum')}>Impressum</Link>
            </li>
            <li className="list-inline-item">
              <Link id="app-footer-agb" to={buildPath('/agb')}>AGB</Link>
            </li>
            <li className="list-inline-item">
              <Link id="app-footer-datenschutz" to={buildPath('/datenschutz')}>Datenschutzerklärung</Link>
            </li>
          </ul>
        </nav>
      </Container>
    </footer>
  );
};

export default AppFooter;
